import { useState, useEffect, useCallback } from "react";
import RewardGroupService from "../../services/RewardGroupService";
import apiClient from "../../auth/apiClient";

const service = new RewardGroupService(apiClient);

const useRewardGroups = (entityID) => {
  const [data, setData] = useState({ totalCount: 0, collection: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({ limit: 10, offset: 0 });

  const fetchRewardGroups = useCallback(async () => {
    if (!entityID) return;
    setLoading(true);
    setError(null);
    try {
      const response = await service.getRewardGroups(entityID, {
        limit: pagination.limit,
        offset: pagination.offset,
      });
      setData(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [entityID, pagination]);

  useEffect(() => {
    fetchRewardGroups();
  }, [fetchRewardGroups]);

  return {
    data,
    loading,
    error,
    pagination,
    setPagination,
    refetch: fetchRewardGroups,
  };
};

export default useRewardGroups;
